import { Box } from '@mui/material'
import React from 'react'
import LogoImage from "../../assets/logo.svg";
import LogoName from "../../assets/logo-name.jpg";
import { Link } from 'react-router-dom';

export default function Logo() {
  return (
    
     <Box sx={{ display: "flex", alignItems: "center" }}>
      <Link to={'https://mydarads.com/dashboard/makeorder '}>
     <img src={LogoImage} alt="logo" sx={{ width: "auto", height: "40px" }} />
     <img src={LogoName} alt="logo name" sx={{ ml: 2 }} />
     </Link>
   </Box>
  )
}
